<template>
  <div>
    <div class="greeting-page">
      <div class="greeting-section">
        <h1>{{ greeting }}!</h1>
        <p>Hello {{ currentUser ? currentUser.first_name : '' }}, Welcome Back</p>
      </div>
      <div class="image-section">
        <div class="shape shape-top" />
        <img
          src="@/assets/images/pages/welcome.svg"
          alt="Delivery Illustration"
          class="illustration"
        >
        <div class="shape shape-bottom" />
        <div class="welcome-footer">
          Powered by CURFOX Delivery Management
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  mapGetters,
} from 'vuex'
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const BusinessRepository = RepositoryFactory.get('businessSetting')

export default {
  data() {
    return {
      greeting: this.getGreeting(),
      form: {},
    }
  },
  computed: {
    ...mapGetters(['currentUser']),
  },
  async mounted() {
    await this.fetchBusinessSettings()
  },
  methods: {
    async fetchBusinessSettings() {
      try {
        this.loading = true
        this.form = localStorage.getItem('businessSettings') ? JSON.parse(localStorage.getItem('businessSettings')) : (await BusinessRepository.getbusinessSettingsResource()).data.data
        if (!localStorage.getItem('businessSettings')) localStorage.setItem('businessSettings', JSON.stringify(this.form))
      } catch (e) {
        // this.convertAndNotifyError(e)
      }
      this.loading = false
    },
    getGreeting() {
      const currentHour = new Date().getHours()
      if (currentHour >= 5 && currentHour < 12) {
        return 'Good Morning'
      } if (currentHour >= 12 && currentHour < 18) {
        return 'Good Afternoon'
      }
      return 'Good Night'
    },
  },
}
</script>

<style scoped>
.greeting-page {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f5f8fa;
  box-sizing: border-box;
  overflow: hidden; /* Prevent scrolling */
}

.greeting-section {
  flex: 1;
  margin-left: 5%;
}

.greeting-section h1 {
  font-size: 2.5em;
  margin: 0;
  color: #333;
}

.greeting-section p {
  font-size: 1.2em;
  color: #777;
  margin-top: 10px;
  font-weight: 500;
}

.image-section {
  flex: 1;
  justify-content: center;
  align-items: center;
  position: relative;
  height: 100%; /* Ensures it adjusts to the height of the container */
}

.illustration {
  max-width: 100%;
  max-height: 100%; /* Ensure it scales down if needed */
  z-index: 2;
  padding-right: 5%;
}

.shape {
  position: absolute;
  background-color: #3498db;
  border-radius: 50%;
  opacity: 0.3;
}

.shape-top {
  width: 50vw;
  height: 50vw;
  top: -35vh;
  left: -30vw;
  z-index: 1;
  transform: translate(-50%, -50%);
}

.shape-bottom {
  width: 50vw;
  height: 50vw;
  top: 5vh;
  left: -15vw;
  z-index: 1;
  transform: translate(-50%, 50%);
}

.welcome-footer {
  text-align: right;
  font-size: 0.9em;
  color: #000000;
  width: 100%;
  font-weight: 500;
  padding: 20px;
}
@media (max-width: 768px) {
  .greeting-page {
    flex-direction: column;
    align-items: center;
    padding: 10px;
  }

  .greeting-section {
    margin-left: 0;
    text-align: center;
    margin-bottom: 20px;
  }

  .greeting-section h1 {
    font-size: 1.8em;
  }

  .greeting-section p {
    font-size: 1em;
  }

  .image-section {
    padding: 0 10px;
  }

  .illustration {
    max-width: 100%;
    max-height: auto;
    padding-right: 0;
  }

  .shape-top {
    width: 40vw;
    height: 40vw;
    top: -5vh;
    left: -10vw;
  }

  .shape-bottom {
    width: 40vw;
    height: 40vw;
    bottom: 0vh;
    left: 0vw;
    transform: translate(200%, 60%);
  }

  .welcome-footer {
    text-align: center;
    font-size: 0.8em;
    padding: 10px;
  }
}
</style>
